import { IEntityFilter, IFilter } from "../../../../context/filters";
import { Filters } from "../../../Results/state/products";
import { IEntityFilterItem } from "../../BaseFilter";

type GetFilterCount = (filterCode: string) => number;

const getFilterCount = (filters: Filters): GetFilterCount => filterCode => {
  const matchingFilter = filters ? filters.find(({ code }) => filterCode === code) : null;
  return matchingFilter ? matchingFilter.count : 0;
};

const mergeFilterCount = (filters: IFilter[], getCount: GetFilterCount): IFilter[] =>
  filters
    .map(filter => ({
      ...filter,
      count: getCount(filter.code)
    }))
    .filter(({ count }) => count > 0);

const mergeEntityFilterCount = (getCount: GetFilterCount) => (
  entityFilter: IEntityFilter
): IEntityFilterItem => {
  const { filters, ...rest } = entityFilter;
  const filterItems = mergeFilterCount(filters, getCount);
  return { filters: filterItems, ...rest };
};

export const getEntityFilterCount = (
  entityFilters: IEntityFilter[],
  filterCount: Filters
): IEntityFilterItem[] => {
  const getCount = getFilterCount(filterCount);
  return entityFilters
    .map(mergeEntityFilterCount(getCount))
    .filter(({ filters }) => filters.length > 0);
};
